import React, { useEffect, useState } from "react";
import { Table, Button, Select, Tooltip, Form, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaEye } from "react-icons/fa";
import {
  CheckOutlined,
  UploadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import {
  getIndustrialvisitmenu,
  resetState,
} from "../features/industrial-visit/industrialSlice";
import ImagePopupModal from "../components/ImagePopupModal";
import { CSVLink } from "react-csv";
import { getBrands } from "../features/brand/brandSlice";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { formatDate } from "../utils/dateHelper";

const Industrialvisit = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectionType] = useState("checkbox");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [vcData, setVcData] = useState([]);
  const [vtData, setVtData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedVC, setSelectedVC] = useState("");
  const [selectedVT, setSelectedVT] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [filteredIndustrialVisit, setFilteredIndustrialVisit] = useState([]);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  const classlistState = useSelector((state) => state.brand.brands || []);
  const { industrialvisits, isLoading } = useSelector(
    (state) => state.industrialvisit
  );

  useEffect(() => {
    dispatch(resetState());
    dispatch(getIndustrialvisitmenu());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  useEffect(() => {
    if (industrialvisits.length > 0 && !initialDataLoaded) {
      setFilteredIndustrialVisit(industrialvisits);
      setInitialDataLoaded(true);
    }
  }, [industrialvisits, initialDataLoaded]);

  const handleImageClick = (images) => {
    setSelectedImages(images);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedImages([]);
  };

  const handleStateChange = (value) => {
    const vcFilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setVcData(vcFilterData);
    setSelectedState(value);
    setSelectedVC("");
    setSelectedVT("");
    setVtData([]);
  };

  const handleVcChange = (value) => {
    const vtFilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setVtData(vtFilterData);
    setSelectedVC(value);
    setSelectedVT("");
  };

  const handleVTChange = (value) => {
    setSelectedVT(value);
  };

  const handleClassChange = (value) => {
    setSelectedClass(value);
  };

  const handleSubmit = () => {
    const filteredData = industrialvisits.filter((visit) => {
      const matchesState = selectedState
        ? visit.userDetails?.state === selectedState
        : true;
      const matchesVT = selectedVT
        ? visit.userDetails?._id === selectedVT
        : true;
      const matchesClass = selectedClass ? visit.class === selectedClass : true;

      return matchesState && matchesVT && matchesClass;
    });
    setFilteredIndustrialVisit(filteredData);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setSelectedVC("");
    setSelectedVT("");
    setSelectedClass("");
    setFilteredIndustrialVisit(industrialvisits);
    setVcData([]);
    setVtData([]);
  };

  const handleApprove = async () => {
    if (selectedRowKeys.length === 0) {
      notification.error({
        message: "No Selection",
        description: "Please select at least one Industrial Visit to approve.",
      });
      return;
    }

    setLoading(true);

    try {
      const userinfo = localStorage.getItem("user");
      const userData = JSON.parse(userinfo);
      const token = userData.token;
      if (!token) {
        throw new Error("Token not found in local storage");
      }

      const docIds = selectedRowKeys;
      await axios.put(
        `${base_url}industrialvisit/approveall`,
        {
          doc_id: docIds,
          approve: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      notification.success({
        message: "Approval Successful",
        description:
          "Selected Industrial Visits have been approved successfully.",
      });
      setSelectedRowKeys([]);
      dispatch(getIndustrialvisitmenu());
    } catch (error) {
      console.error("Error approving Industrial Visit:", error);
      notification.error({
        message: "Approval Failed",
        description: "There was an error approving the Industrial Visits.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "key",
      title: "Sr No",
      width: 70,
    },
    {
      dataIndex: "date",
      title: "Schedule Date",
      width: 120,
      render: (text) => formatDate(text) || "N/A",
    },
    {
      dataIndex: "class",
      title: "Class",
      width: 80,
    },
    {
      dataIndex: "company_name",
      title: "Company Name",
      width: 150,
    },
    {
      dataIndex: "location_name",
      title: "Location Name",
      width: 150,
    },
    {
      dataIndex: "trade",
      title: "Trade",
      width: 130,
    },
    {
      dataIndex: "created_by",
      title: "Scheduled By",
      width: 150,
    },
    {
      dataIndex: "school_name",
      title: "School Name",
      width: 150,
    },
    {
      dataIndex: "student_count",
      title: "Student Count",
      width: 100,
    },
    {
      dataIndex: "approve_status",
      title: "Approve Status",
      width: 100,
      render: (text) => (text ? "Yes" : "No"),
    },
    {
      dataIndex: "approve_by",
      title: "Approved By",
      width: 150,
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      width: 150,
      render: (text) => formatDate(text) || "N/A",
    },
    {
      dataIndex: "uploaded_doc",
      title: "Uploaded Doc",
      width: 100,
      render: (text, record) => (
        <Button
          shape="circle"
          icon={<UploadOutlined />}
          onClick={() => handleImageClick(record.uploaded_doc)}
        />
      ),
    },
  ];

  const data1 = Array.isArray(filteredIndustrialVisit)
    ? filteredIndustrialVisit.map((visit, index) => {
        const extractUrls = (images) =>
          images?.map((image) => ({ url: image.url })) || [];

        return {
          key: index + 1,
          doc_id: visit.industrialVisitId, // Use industrialVisitId from API
          date: visit.date,
          class: visit.class,
          company_name: visit.company_name || "N/A",
          location_name: visit.location_name || "N/A",
          trade: visit.trade || "N/A",
          created_by: visit.userDetails?.name || "N/A",
          school_name: visit.userDetails?.school_name || "N/A",
          student_count: visit.student_count || "N/A",
          approve_status: visit.approve || false,
          approve_by: visit.approvedByDetails?.name || "N/A",
          created_at: visit.createdAt || "N/A",
          uploaded_doc: [
            ...extractUrls(visit.image_start),
            ...extractUrls(visit.image_mid),
            ...extractUrls(visit.image_last),
            ...extractUrls(visit.image_signedform),
          ],
        };
      })
    : [];

  const csvHeaders = [
    { label: "Date", key: "date" },
    { label: "Class", key: "class" },
    { label: "Company Name", key: "company_name" },
    { label: "Location Name", key: "location_name" },
    { label: "Trade", key: "trade" },
    { label: "Scheduled By", key: "created_by" },
    { label: "School Name", key: "school_name" },
    { label: "Student Count", key: "student_count" },
    { label: "Approve Status", key: "approve_status" },
    { label: "Approved By", key: "approve_by" },
    { label: "Created At", key: "created_at" },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      const docIds = selectedRows.map((row) => row.doc_id);
      setSelectedRowKeys(docIds);
    },
    getCheckboxProps: (record) => ({
      disabled: record.approve_status === true, // Disable if approved
    }),
  };

  return (
    <div>
      <h3 className="mb-4 title">Industrial Visits</h3>

      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item name="state_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select State"
              onChange={handleStateChange}
              value={selectedState}
            >
              <Select.Option value="">Select State</Select.Option>
              {statelistState.map((state) => (
                <Select.Option key={state.state} value={state.state}>
                  {state.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="vc_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VC"
              onChange={handleVcChange}
              value={selectedVC}
              disabled={!selectedState}
            >
              <Select.Option value="">Select VC</Select.Option>
              {vcData
                .filter((item) => item.role === "vc")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="vt_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VT"
              onChange={handleVTChange}
              value={selectedVT}
              disabled={!selectedVC}
            >
              <Select.Option value="">Select VT</Select.Option>
              {vtData
                .filter((item) => item.role === "vt")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="class_name">
            <Select
              style={{ width: 160 }}
              placeholder="Select Class"
              onChange={handleClassChange}
              value={selectedClass}
            >
              <Select.Option value="">Select Class</Select.Option>
              {classlistState.map((cls) => (
                <Select.Option key={cls.title} value={cls.title}>
                  {cls.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginRight: 20 }}
              type="primary"
              htmlType="submit"
            >
              <FaEye /> View
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Tooltip title="Approve Selected Industrial Visits">
        <Button
          type="primary"
          shape="round"
          icon={<CheckOutlined />}
          style={{ backgroundColor: "rgb(45, 143, 36)", marginRight: 16 }}
          onClick={handleApprove}
          loading={loading}
          disabled={loading || selectedRowKeys.length === 0}
        >
          Approve
        </Button>
      </Tooltip>
      <CSVLink
        data={data1}
        headers={csvHeaders}
        filename={`industrial-visit_${new Date().toISOString()}.csv`}
      >
        <Button type="primary">
          <ExportOutlined /> Export to CSV
        </Button>
      </CSVLink>

      {isLoading ? (
        <div>Loading...</div>
      ) : filteredIndustrialVisit.length === 0 ? (
        <div>No industrial visits found</div>
      ) : (
        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          columns={columns}
          dataSource={data1}
          style={{ marginTop: 16 }}
          scroll={{ x: 1300 }} // Enable horizontal scrolling
        />
      )}

      <ImagePopupModal
        visible={modalVisible}
        images={selectedImages}
        onClose={closeModal}
      />
    </div>
  );
};

export default Industrialvisit;
